var prdTableLink = (function () {
    var config = {
        dropdownTrigger: "#prdTableLinkContainer .dropdown-trigger",
        dropdownContent: "#prdTableLinkContainer .dropdown-content",
        dropdownLinks: "#prdTableLinkContainer .dropdown-content a",
        dropdownSelectedText: "#prdTableLinkContainer .dropdown-trigger .text",
        dropdown: "#prdTableLinkContainer #prdTablelinkDropdown",
        prdTableLinks: "#prdTableLinkContainer #prdTableLinkNav a",
        prdTableLinkNav: "#prdTableLinkContainer #prdTableLinkNav",
        prdTableLinkContainer: "#prdTableLinkContainer",
        mobileMaxWidth: 768,
        maxprdTableLinkHeight: 30,
        resizeTimeout: null,
    };

    function prdTableLink() { }

    prdTableLink.prototype.init = function () {
        var self = this;

        // Dropdown click event
        $(config.dropdownTrigger).on("click", function (e) {
            self.handleDropdownClick(e);
        });

        // Dropdown links click event
        $(config.dropdownLinks).on("click", function (e) {
            self.handleDropdownLinkClick(e, this);
            self.closeDropdown(e);
        });

        // Window click event
        $(window).on("click", function (e) {
            self.closeDropdown(e);
        });

        // prdTable links click event
        $(config.prdTableLinks).on("click", function (e) {
            self.handleprdTableLinkClick(e, this);
        });

        // Set active link based on URL hash only on page load
        self.setActiveLinkFromUrl();
    };

    prdTableLink.prototype.handleDropdownClick = function (e) {
        $(config.dropdownContent).toggleClass("showdropdown");
        e.stopPropagation();
    };
    prdTableLink.prototype.closeDropdown = function (e) {
        if (!$(config.dropdownTrigger).is(e.target)) {
            $(config.dropdownContent).removeClass("showdropdown");
        }
    };

    prdTableLink.prototype.handleDropdownLinkClick = function (event, elem) {
        var selectedText = $(elem).text();

        // Remove active class from all dropdown and nav links
        $(config.dropdownLinks).removeClass("active");
        $(config.prdTableLinks).removeClass("active");

        // Set the active class on the clicked dropdown link
        $(elem).addClass("active");
        $(config.dropdownSelectedText).text(selectedText);

        // Find and activate the corresponding nav link
        var hash = $(elem).attr('href');
        $(config.prdTableLinks).each(function () {
            if ($(this).attr('href') === hash) {
                $(this).addClass("active");
            }
        });
    };

    prdTableLink.prototype.handleprdTableLinkClick = function (event, elem) {
        // Remove active class from all dropdown and nav links
        $(config.prdTableLinks).removeClass("active");
        $(config.dropdownLinks).removeClass("active");

        // Set the active class on the clicked nav link
        $(elem).addClass("active");

        // Find and activate the corresponding dropdown link
        var hash = $(elem).attr('href');
        $(config.dropdownLinks).each(function () {
            if ($(this).attr('href') === hash) {
                $(this).addClass("active");
                $(config.dropdownSelectedText).text($(this).text());
            }
        });
    };

    // This function will only run on page load to set the initial active link based on the URL hash
    prdTableLink.prototype.setActiveLinkFromUrl = function () {
        var currentHash = window.location.hash;  // Get the hash from the URL
        if (currentHash) {
            var decodedHash = decodeURIComponent(currentHash);  // Decode the hash

            // Set active class for dropdown links
            $(config.dropdownLinks).each(function () {
                var linkHref = decodeURIComponent($(this).attr('href'));  // Decode the href before comparing
                if (linkHref === decodedHash) {
                    $(config.dropdownLinks).removeClass("active");
                    $(this).addClass("active");
                    $(config.dropdownSelectedText).text($(this).text());
                }
            });

            // Set active class for prdTable links
            $(config.prdTableLinks).each(function () {
                var linkHref = decodeURIComponent($(this).attr('href'));  // Decode the href before comparing
                if (linkHref === decodedHash) {
                    $(config.prdTableLinks).removeClass("active");
                    $(this).addClass("active");
                }
            });
        }
    };

    return prdTableLink;
})();

$(document).ready(function () {
    if ($("#prdTableLinkContainer").length > 0) {
        var prdTableLinkInstance = new prdTableLink();
        prdTableLinkInstance.init();
    }
});